import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styleClasses from './css/Share.module.scss';

const Share = ({ url, musician, image }) => {
  let musicianDescription = '';
  if (musician.genres) {
    const genreArray  = (musician.genres).map(item => `#${ item }`);
    const genreString = genreArray.join(' ');
    
    musicianDescription = genreString;
  }
  if (musician.positions) {
    const positionArray   = (musician.positions).map(item => `#${ item }`);
    const positionString  = positionArray.join(' ');
    
    if (musicianDescription !== '') musicianDescription += ', ' + positionString;
    else                            musicianDescription = positionString;
  }

  const [complete, setComplete] = useState('');
  const [copiedInstagram, setCopiedInstagram] = useState('');

  // Naver
  const shareNaver = () => {
    window.open(`https://share.naver.com/web/shareView?url=${encodeURIComponent(url)}&ref=naver&title=${encodeURIComponent(musician.name)}`);
  };

  // Instagram
  const shareInstagram = () => {
    navigator.clipboard.writeText(`${ window.location.href }?ref=instagram`)
    .then(() => {
      setCopiedInstagram(styleClasses.fadeIn);
      setTimeout(() => { setCopiedInstagram(styleClasses.fadeOut) }, 2500);
      setTimeout(() => { setCopiedInstagram('') }, 3000);
    })
    .catch(() => {
      alert('Failed to copy the link.'); // 복사 실패 시 알림
    });
  }

  // Facebook
  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&ref=facebook`, '_blank');
  };

  // X (Twitter)
  const shareX = () => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&ref=x&text=${encodeURIComponent(musician.name)}`, '_blank');
  };

  // WhatsApp
  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${url}?ref=whatsApp`)}`, '_blank');
  };

  // Line
  const shareLine = () => {
    window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(`${url}?ref=line`)}`, '_blank');
  };
  console.log(process.env.REACT_APP_KAKAO_API_KEY);
  // Kakao Talk
  useEffect(() => {
    // Kakao SDK 로드
    const script       = document.createElement("script");
    script.src         = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.4/kakao.min.js";
    script.integrity   ="sha384-DKYJZ8NLiK8MN4/C5P2dtSmLQ4KwPaoqAfyA/DfmEc1VDxu4yyC7wy6K1Hs90nka";
    script.crossOrigin = "anonymous";
    script.onload = () => {
      if (window.Kakao) {
        // Kakao SDK 초기화
        window.Kakao.init(process.env.REACT_APP_KAKAO_API_KEY); // .env

        // 공유 버튼 생성
        window.Kakao.Share.createDefaultButton({
          container : "#kakaotalk-sharing-btn",
          objectType: "feed",
          content   : {
            title       : musician.name,
            description : musicianDescription,
            imageUrl    : musician.profileImage ,
            link        : {
              mobileWebUrl: `${ url }?ref=kakaotalk`,
              webUrl      : `${ url }?ref=kakaotalk`
            },
          },
          buttons: [
            {
              title : "웹으로 보기",
              link  : {
                mobileWebUrl: `${ url }?ref=kakaotalk`,
                webUrl      : `${ url }?ref=kakaotalk`
              },
            }
          ],
        });
      }
    };
    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, [musician, musicianDescription, url]);

  const copyLink  = () => {        
    navigator.clipboard.writeText(url)
    .then(() => {
      setComplete(styleClasses.complete);
      setTimeout(() => { setComplete('') }, 1500);
    })
    .catch(() => {
      alert('Failed to copy the link.'); // 복사 실패 시 알림
    });
  }

  return (
    <div className={ styleClasses.share }>
      <div className={ styleClasses.socialMedias }>
        {/* 카카오톡 */}
        <button id="kakaotalk-sharing-btn">
            <img className={ styleClasses.kakao } src="https://developers.kakao.com/assets/img/about/logos/kakaotalksharing/kakaotalk_sharing_btn_medium.png" alt="카카오톡 공유 보내기 버튼" />
        </button>
        <button onClick={ shareNaver }>
          <img src="https://developers.naver.com/inc/devcenter/dist/0739723a031b354f5311473e386d3eb1.png" alt="" />
        </button>
        <button onClick={ shareInstagram }>
          <i className={ styleClasses.instagram }></i>
          <div className={`${ styleClasses.toast } ${ copiedInstagram }`}>
            <div className={ styleClasses.inner }>
              {
                navigator.language === 'ko'
                ?
                <p>복사가 완료되었습니다! <br />인스타그램에 붙여넣고 공유해 보세요.</p>
                :
                <p>Copy complete! <br />Paste it on Instagram and share.</p>
              }
            </div>
          </div>
        </button>
        <button onClick={ shareFacebook }>
          <i className={ styleClasses.facebook }></i>
        </button>
        <button onClick={ shareX }>
          <i className={ styleClasses.x }></i>
        </button>
        <button onClick={ shareWhatsApp }>
          <i className={ styleClasses.whatsApp }></i>
        </button>
        <button onClick={ shareLine }>
          <i className={ styleClasses.line }></i>
        </button>
      </div>
      <div className={ styleClasses.copyBox }>
        <input type="text" value={ url } />
        <button onClick={ copyLink }>
          <div className='commonIcon'>
            <i className='shareWhite w24'></i>
          </div>
          <div className={`${ styleClasses.completeBox } ${ complete }`}>
            <div className='commonIcon'>
              <i className='checkWhite w32'></i>
            </div>
          </div>
        </button>
      </div>
      {
        image && (
          <div className={ styleClasses.downloadBox }>
            <Link className={ styleClasses.downloadIcon } to={ image } target='_blank' download={ true }>
              <div className='commonIcon'>
                <i className='downloadWhite w24'></i>
              </div>
            </Link>
            <Link className={ styleClasses.downloadImage } to={ image } target='_blank' download={ true }>
              <img src={ image } alt={ musician.name } />
            </Link>
          </div>
        )
      }
    </div>
  )
}

export default Share;